<template lang="pug">
    div(:class="{ _con: reset, _page: page, _row: row }")
        slot
</template>

<script>
    import telemetry from '../private/telemetry'

    /**
     * This component resets all formatting styles to their initial values, and is typically
     * used as the top level element in a component. It is frequently used as a row in the
     * grid system.
     */
    export default {
        name: 'ib-context',

        mixins: [
            telemetry
        ],

        props: {
            /**
             * If true, reset CSS formatting to initial state; this prevents formatting from
             * the parent context from affecting this context. By default, this is true.
             */
            reset: {
                type: Boolean,
                default: true
            },
            /**
             * If true, occupy all available screen space (minus margins for web platform).
             * Typically used for your application's top level context.
             */
            page: Boolean,
            /**
             * If true, treat this element as an `ib-row`.
             */
            row: Boolean
        },

        data() {
            return {
                tmListen: false
            };
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._con {
        font: initial;
        font-family: @font-family;
        .font-size(@fs6);
        .line-height-auto(@fs6);
        color: @fg;
        letter-spacing: initial;
        text-align: initial;
        text-align-last: initial;
        text-indent: initial;
        text-justify: initial;
        text-shadow: initial;
        white-space: initial;
        word-break: initial;
        word-spacing: initial;
        word-wrap: initial;
        float: initial;

        &._page {
            position: relative;
            margin: 0 auto;
            width: 100%;
            height: 100%;
        }
    }
</style>

<docs>
    Refer to [Grid Docs](/#!/Styles?id=grid) for overall grid layout information
</docs>
